import { useCallback, useState } from 'react';
import { Resolucao, Simulado } from '../../sdk/@types';
import InscritoService from '../../sdk/services/InscritoService';
import ResolucaoService from '../../sdk/services/ResolucaoService';
import { readApiError } from '../../sdk/errors/apiError';

/** Desfecho de `registrarInscricao` — nunca rejeita, sempre resolve a um destes três. */
export type InscricaoOutcome =
  | { kind: 'sucesso' }
  | { kind: 'conflito' }
  | { kind: 'falha'; raw: string };

export default function useInscrito() {
  const [inscrito, setInscrito] = useState<Simulado.Inscrito>(
    {
      id: '',
      situation: 'inscrito',
      registry_date: '',
    });

  const [inscritos, setInscritos] = useState<Simulado.Inscrito[]>([]);
  const [rankeds, setRankeds] = useState<Simulado.Inscrito[]>([]);
  const [resolucoes, setResolucoes] = useState<Resolucao.ResolucaoQuestao[]>([]);

  const newInscrito = useCallback(() => {
    setInscrito({
      id: '',
      situation: 'inscrito',
      registry_date: '',
      rank: '',
      user: undefined,
      mocktest: undefined,
    });
  }, []);

  const fetchInscrito = useCallback(async (inscritoId: string) => {
    setInscrito(await InscritoService.getInscrito(inscritoId) );
  }, []);

  const fetchInscritos = useCallback(async () => {
    setInscritos(await InscritoService.getInscritos());
  }, []);

  const fetchRankeds = useCallback(async (mocktestID : string) => {
    setRankeds(await InscritoService.getRankeds(mocktestID));
  }, []);

  const fetchResolucoes = useCallback(async (registeredID: string) => {
    setResolucoes(await ResolucaoService.getRegisteredResolutions(registeredID));
  }, []);

  const registrarInscricao = useCallback(async (inscricao : Simulado.Inscrito): Promise<InscricaoOutcome> => {
    try {
      await InscritoService.inserirNovoInscrito(inscricao);
      return { kind: 'sucesso' };
    } catch (err) {
      const apiError = readApiError(err);
      if (apiError.status === 409) {
        return { kind: 'conflito' };
      }
      return { kind: 'falha', raw: apiError.raw };
    }
  }, []);

  const removerInscricao = useCallback(async (simuladoId : string) => {
    await InscritoService.deletePorSimuladoId(simuladoId);
  }, []);

  return {
    inscrito,
    rankeds,
    inscritos,
    resolucoes,
    newInscrito,
    registrarInscricao,
    removerInscricao,
    fetchInscrito,
    fetchInscritos,
    fetchRankeds,
    fetchResolucoes
  };
}
